import { ApiClient } from '@webapp/core/services/ApiClient'
import { PaymentMethodRepository } from './PaymentMethodRepository'

export const paymentMethodRepository = new PaymentMethodRepository({
  httpClient: ApiClient,
})
